import Button from 'components/button';
import Title from 'components/title';
import { generateToastErrorMsg } from 'components/toast/utils';
import { t } from 'i18next';
import NewsForm, { INewsFormValues } from 'pages/admin/newsManagePage/components/newsForm';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ICreateNewsData, useCreateNews } from 'services/news';
import { getCurrentLng } from 'utils/getCurrentLng';

import { DEFAULT_LOCALE } from '@app/common/helpers';

const AddNewNewsPage: React.FC = () => {
  const currentLng = useSelector(getCurrentLng);
  const navigate = useNavigate();
  const createNewNewsService = useCreateNews();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleAddNewNews = useCallback(
    async (values: INewsFormValues) => {
      setIsLoading(true);
      try {
        const newsData: ICreateNewsData = {
          newsTitleVi: values.newsTitleVi,
          newsTitleEn: values.newsTitleEn,
          newsIntroductionVi: values.newsIntroductionVi,
          newsIntroductionEn: values.newsIntroductionEn,
          newsContentVi: values.newsContentVi,
          newsContentEn: values.newsContentEn,
          newsCoverImage: values.newsCoverImg as File,
          status: values.status
        };
        const response = await createNewNewsService(newsData);
        if (response.success) {
          toast.success(
            t('admin.text.action_success_message')
              .replace('{item_name}', currentLng === DEFAULT_LOCALE ? response.data.newsTitleVi : response.data.newsTitleEn)
              .replace('{action_name}', t('admin.text.create_action_name'))
          );

          navigate(-1);
        }
      } catch (error) {
        toast.error(generateToastErrorMsg(error as string | string[]));
      } finally {
        setIsLoading(false);
      }
    },
    [currentLng]
  );

  return (
    <div className='w-full space-y-30px'>
      <div className='w-full border-b border-hl-gray-x11'>
        <Title text={t('admin.label.add_new_news')} />
      </div>

      <div className='w-full space-y-4'>
        <NewsForm onSubmit={handleAddNewNews} loading={isLoading} />

        <div className='flex w-full items-center justify-center'>
          <Button type='button' buttonVariant='link' label={t('button_label.back')} onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  );
};

export default AddNewNewsPage;
